/* Product details accordion: deep-linkable rows (OL-3770).

   The row's anchor_id renders as a real id on the .product-details__card
   wrapper, so the browser handles scrolling on its own and a link works
   with this file absent. What it cannot do is open the row, since browsers
   do not reliably auto-open a closed <details> on hash navigation, so that
   is all this script adds.

   Two row shapes: a <details> (opened via .open) and the Description
   card's <component-read-more> (expanded via its own toggleContent). */
(function () {
  function openRow(card) {
    if (!card) return false;

    var details = card.querySelector('details');
    if (details) {
      if (details.open) return false;
      details.open = true;
      return true;
    }

    var readMore = card.querySelector('component-read-more');
    if (readMore && typeof readMore.toggleContent === 'function' && readMore.classList.contains('read-more--collapsed')) {
      readMore.toggleContent();
      return true;
    }

    return false;
  }

  function handleHash() {
    var hash = window.location.hash;
    if (!hash || hash.length < 2) return;

    var id = hash.slice(1);
    try {
      id = decodeURIComponent(id);
    } catch (error) {
      // Malformed percent-encoding, use the raw value.
    }

    var target = document.getElementById(id);
    if (!target || !target.classList.contains('product-details__card')) return;

    // Opening the row changes its height, so the browser's own scroll to the
    // fragment is now short. Re-scroll only when we actually opened it.
    if (!openRow(target)) return;

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', handleHash);
  window.addEventListener('hashchange', handleHash);
})();
